import { render, staticRenderFns } from "./base_Fgrid.vue?vue&type=template&id=57c010d3"
import script from "./base_Fgrid.vue?vue&type=script&lang=js"
export * from "./base_Fgrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports